import { ProductTypeEnum } from "@/requests/gen/react-query/fastAPI.schemas";
import {
  createLoader,
  parseAsString,
  parseAsBoolean,
  parseAsInteger,
  parseAsArrayOf,
  parseAsStringEnum,
} from "nuqs";

export const dataTableSearchParsers = {
  search: parseAsString,
  created_at_start: parseAsString,
  created_at_end: parseAsString,
  updated_at_start: parseAsString,
  updated_at_end: parseAsString,
  sort_column: parseAsString,
  ascending: parseAsBoolean,
  page: parseAsInteger.withDefault(1),
  limit: parseAsInteger.withDefault(10),
  is_deleted: parseAsBoolean,
  only_samples: parseAsBoolean.withDefault(false),
  hidden: parseAsArrayOf(parseAsString),
  product_types: parseAsArrayOf(
    parseAsStringEnum(Object.values(ProductTypeEnum)),
  ).withDefault([]),
  entity_ids: parseAsArrayOf(parseAsInteger).withDefault([]),
  practice_ids: parseAsArrayOf(parseAsInteger).withDefault([]),
};

/**
 * Parse a URL search string into the data-table search params.
 * Use in a route `loader` to prefetch a lookup table's query so it paints
 * populated instead of flickering: `loadDataTableSearch(location.searchStr)`.
 */
export const loadDataTableSearch = createLoader(dataTableSearchParsers);
